import React from 'react';
import { hasReviewGroup, isReviewGroupLead } from '@printdeal/business-logic';

import LineItemCard from '../LineItem/LineItemCard';
import { SanitizedLineItem } from '../../../../../types/order/Order';

const LineItemContext = React.createContext({});

interface LineItemListProps {
  lineItems: SanitizedLineItem[];
}

const LineItemList = ({ lineItems }: LineItemListProps) => {
  const mainLineItems = lineItems.filter(
    (lineItem) => isReviewGroupLead(lineItem) || !hasReviewGroup(lineItem),
  );

  return (
    <>
      {
        mainLineItems.map((lineItem) => (
          <LineItemContext.Provider value={lineItem} key={lineItem.id}>
            <LineItemCard
              lineItem={lineItem}
            />
          </LineItemContext.Provider>
        ))
      }
    </>
  );
};

export default LineItemList;
